import { MakeCall } from './createMakeCall';
import { UserSearch } from './types/UserSearch';
import { APIV2_URL } from './constants';

interface UserSearchPayload {
  city: string;
  country: string;
  startDate?: string;
  endDate?: string;
  kinds?: Array<'entire place' | 'private room' | 'shared room'>;
  types?: Array<'house' | 'building' | 'apartment'>;
  minPrice?: number;
  maxPrice?: number;
  currency?: string;
}

export type SaveSearchCall = (
  id: number,
  data: UserSearchPayload,
) => Promise<{ data: UserSearch }>;

export default (makeCall: MakeCall) => (id: number, data: UserSearchPayload) =>
  makeCall<UserSearch>('POST', `${APIV2_URL}/user/${id}/search`, {
    data,
  });
